import React from 'react';

export default function Events() {
  const summitUrl = 'https://aws.amazon.com/es/events/summits/madrid/';

  const events = [
    {
      title: 'Analytics multi-motor en SageMaker Lakehouse con AWS Lake Formation',
      track: 'Track 2',
      level: 'Advanced',
      speakers: 'Andrea Perez Isla and Alberto Menendez',
      event: 'AWS Madrid Summit 2025',
      icon: '📊',
    },
    {
      title: 'Prueba otra vez: cómo crear sistemas resilientes',
      track: 'Track 3',
      level: 'Advanced',
      speakers: 'Enrique Alejo, Cloud Architect, AWS | Alberto Menéndez, Delivery Specialist, AWS',
      event: 'AWS Madrid Summit 2025',
      icon: '🔄',
    },
  ];

  return (
    <section id="events" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Events & Talks
          </h2>
          <p className="text-base md:text-lg lg:text-xl text-gray-600 max-w-2xl mx-auto">
            Conferences and sessions I&apos;ve presented at, including AWS Summit Madrid
          </p>
        </div>

        <div className="space-y-8">
          {events.map((evt, index) => (
            <a
              key={index}
              href={summitUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="block bg-white border-2 border-gray-200 rounded-xl p-6 hover:shadow-xl hover:border-blue-500 transition group"
            >
              <div className="flex flex-col sm:flex-row sm:items-start gap-4">
                <div className="flex-shrink-0 w-14 h-14 bg-blue-100 rounded-xl flex items-center justify-center text-3xl group-hover:bg-blue-200 transition">
                  {evt.icon}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex flex-wrap items-center gap-2 mb-2">
                    <span className="px-2 py-0.5 bg-blue-100 text-blue-700 text-xs font-medium rounded">
                      {evt.event}
                    </span>
                    <span className="px-2 py-0.5 bg-gray-200 text-gray-600 text-xs font-medium rounded">
                      {evt.track}
                    </span>
                    <span className="px-2 py-0.5 bg-amber-100 text-amber-800 text-xs font-medium rounded">
                      {evt.level}
                    </span>
                  </div>
                  <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-2 group-hover:text-primary transition">
                    {evt.title}
                  </h3>
                  <p className="text-sm md:text-base text-gray-600">
                    <span className="font-medium text-gray-700">Speakers:</span> {evt.speakers}
                  </p>
                  <span className="inline-flex items-center gap-1 text-sm font-medium text-primary mt-2">
                    View summit
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                    </svg>
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
